"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStack = void 0;
const logic_types_1 = require("../logic-types");
class CardStack {
    get displayCards() {
        return this.allFaceCards
            .map((card) => card.displayDescription())
            .join(", ");
    }
    get allFaceCards() {
        const pile = this.board.getPileByPileId(this.pileId);
        return pile.allCards.filter((card) => card.isFaceUp);
    }
    get containsWild() {
        return this.allFaceCards.some((card) => { var _a; return ((_a = card.cardId) === null || _a === void 0 ? void 0 : _a.cardSuit) === logic_types_1.CardSuit.Wild; });
    }
    get cardCount() {
        return this.allFaceCards.length;
    }
    constructor(pileId, board, logicVersion) {
        this.pileId = pileId;
        this.board = board;
        this.logicVersion = logicVersion;
    }
    clone() {
        return new CardStack(this.pileId, this.board.clone(), this.logicVersion);
    }
}
exports.CardStack = CardStack;
